import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IFinancingCompanyResponse, IFinancingCompanyState } from '../../types'

const adminApiClient = AdminApiClient.getInstance()

export const fetchShowFinancingCompany = createAsyncThunk(
  'listFinancingCompanies/fetchShowFinancingCompany',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await adminApiClient.financingCompany(id)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: IFinancingCompanyState = {
  isLoading: false,
  response: null,
  error: null
}

const showFinancingCompanySlice = createSlice({
  name: 'financingCompanies/show',
  initialState,
  reducers: {
    resetShowFinancingCompany: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchShowFinancingCompany.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchShowFinancingCompany.fulfilled, (state, action: PayloadAction<IFinancingCompanyResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchShowFinancingCompany.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default showFinancingCompanySlice.reducer
export const { resetShowFinancingCompany } = showFinancingCompanySlice.actions
